import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
import {LayoutType} from "../../constants";
import {Shower} from "../../parts/shower";
import {IS_BATHROOM_OLD_BV_SCENE} from "../../../../../config";

export default class RightWall extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'right_wall';
    this.partName = 'Right Wall';
    this.translateId = "visualizer.bathroom.walls.right_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    this.partsLayouts = [LayoutType.Layout1];
  }

  load(dbFeature) {
    const partsRoomLayouts = this.partsLayouts.map(pl => "Layout"+pl);
    const isPartFeature = !dbFeature.metaData["RoomLayout"] || partsRoomLayouts.some(layoutType => {
      return dbFeature.metaData["RoomLayout"].includes(layoutType)
    });
    if (isPartFeature) {
      const part1 = dbFeature.metaData["LayerType"] && dbFeature.metaData["MirrorSize"];
      const partNumber = part1 ? 1 : 2;
      return super.load_(dbFeature, new RightWall(false, partNumber),
        true, partNumber === 1 ? 'features' : 'featuresParts');
    }
    return super.load_(dbFeature, new RightWall(false, 1, true, "features"));
  }

  availableFeatures(cabinetFeatures) {
    return cabinetFeatures.filter(cabinetFeature => cabinetFeature.partNumber === 1)
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      this.checkIfFeaturePartIsMatching();
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const wallsParent = this.getParent();
    const layout = wallsParent.layout;
    const mirror = layout.parts[Vanity.id] && layout.parts[Vanity.id].mirror;
    if (this.partsLayouts.includes(layout.type) && mirror && mirror.activeFeature && mirror.activeFeature.dbFeature.metaData["MirrorSize"]) {
      conditions.push({
        propName: "MirrorSize",
        propValue: IS_BATHROOM_OLD_BV_SCENE
          ? mirror.activeFeature.dbFeature.metaData["MirrorSize"][0]
          : mirror.activeFeature.dbFeature.metaData["MirrorSize"][0] === "32" ? "48" : mirror.activeFeature.dbFeature.metaData["MirrorSize"][0]
    })
    }
    const shower = this.getParent().layout.parts[Shower.id];
    if (shower && shower.showerSize()) {
      conditions.push({
        propName: "ShowerSize",
        propValue: shower.showerSize()
      })
    }
    return conditions;
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    return this.getActiveFeaturePartsAccordingToActiveFeature(fromFeature, activeFeatureConditions);
  }

  setZIndex(zIndexes) {
    const layout = this.getParent().layout;
    const isPartsLayout = this.partsLayouts.includes(layout.type);
    if (zIndexes) {
      const zIndex = isPartsLayout ? zIndexes.Walls.RightWall : zIndexes.Background.RightWall;
      const zIndex2 = zIndexes.Background.RightWall;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
      if (this.activeFeatureParts && this.activeFeatureParts.length) {
        this.activeFeatureParts.forEach((activeFeaturePart) => {
          if (activeFeaturePart && activeFeaturePart.layer) {
            activeFeaturePart.layer.zIndex = zIndex2;
          }
        })
      }
    }
  }
}
